import type { ReactNode } from 'react';
import { useGameStore } from '../state/gameStore';
import { Icon } from './Icon';

export function PanelShell({
  eyebrow,
  title,
  children,
  wide = false
}: {
  eyebrow: string;
  title: string;
  children: ReactNode;
  wide?: boolean;
}) {
  const setPanel = useGameStore((state) => state.setPanel);
  return (
    <div className="panel-scrim" role="presentation" onMouseDown={() => setPanel('none')}>
      <section
        className={wide ? 'game-panel game-panel--wide' : 'game-panel'}
        role="dialog"
        aria-modal="true"
        aria-labelledby="panel-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="game-panel__header">
          <div>
            <span className="eyebrow">{eyebrow}</span>
            <h2 id="panel-title">{title}</h2>
          </div>
          <button className="icon-button" aria-label="Close panel" onClick={() => setPanel('none')}>
            <Icon name="close" size={20} />
          </button>
        </header>
        <div className="game-panel__body">{children}</div>
      </section>
    </div>
  );
}

